import { Component, ElementRef, Input, ViewChild, OnInit } from '@angular/core';

import { ApiError, ConfigServerService, JwtService, MessageService } from '../../../../core';
import { FileUploader, FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import { Usuario } from '../../usuario';
import { UsuarioFileManagerService } from '../../services';
import { UsuarioEmailAssinaturaService } from '../services';

@Component({
    selector: 'sgt-usuario-email-assinatura-upload',
    templateUrl: './usuario-email-assinatura-upload.component.html',
    styleUrls: ['./usuario-email-assinatura-upload.component.less']
})
export class UsuarioEmailAssinaturaUploadComponent implements OnInit {
    @Input() entity: Usuario;

    @ViewChild('inputFile') inputFile: ElementRef;
    uploader: FileUploader;

    constructor(private configServerService: ConfigServerService,
                private jwtService: JwtService,
                private messageService: MessageService,
                private usuarioFileManagerService: UsuarioFileManagerService,
                private usuarioEmailAssinaturaService: UsuarioEmailAssinaturaService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o uploader para realizar o upload da imagem da assinatura */
    private create() {
        this.uploader = new FileUploader({
            method: 'PUT',
            url: `${this.configServerService.getPathApi()}/usuario/${this.entity.id}/upload/assinaturaemail`,
            authToken: this.jwtService.accessTokenWithBearer,
            autoUpload: true
        });

        this.onAfterAddingFile();
        this.onCompleteItem();
        this.onCompleteAll();
    }

    /** Após selecionar o arquivo */
    private onAfterAddingFile() {
        this.uploader.onAfterAddingFile = (fileItem: FileItem): any => {
             fileItem.withCredentials = false;
             // Gerando a visualiza temporária da imagem selecionada
             // const reader = new FileReader();
             // reader.readAsDataURL(fileItem._file);
             // reader.onload = (e: any) => {
             //     this.urlAssinaturaEmailTemp = e.target.result;
             // }
        }
    }

    /** Ao completear o upload da imagem */
    private onCompleteItem() {
        this.uploader.onCompleteItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any => {
            switch (status) {
                case 200: // OK
                    this.entity.urlAssinaturaEmail = response;
                    this.usuarioEmailAssinaturaService.next(this.entity.urlAssinaturaEmail);
                    break;
                default: // Demais erros
                    const error = JSON.parse(response) as ApiError;
                    this.messageService.error(error.message, 'Erro ao realizar o upload da assinatura de e-mail', error);
                    break;
           }
       };
    }

    /** Ao completar o upload */
    private onCompleteAll() {
        this.uploader.onCompleteAll = () => {
             this.clearInputFile();
        };
    }

    /** Limpa o input file da assinatura de e-mail */
    private clearInputFile() {
        const el = this.inputFile.nativeElement as HTMLInputElement;
        el.value = '';
    }

    /** Exclui a assinatura de e-mail */
    delete() {
        // Removendo do servidor
        this.usuarioFileManagerService.deleteAssinaturaEmail(this.entity.id)
            .subscribe(
                () => {
                    this.entity.urlAssinaturaEmail = null;
                    this.usuarioEmailAssinaturaService.next(this.entity.urlAssinaturaEmail);
                    this.clearInputFile();
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao excluir a assinatura de e-mail', error)
            );
    }
}
